import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getUserManagerAsync } from  './OidcConfig'

const ProtectedRoute = () => {
  const [user, setUser] = useState(null); // State to store the user
  const [loading, setLoading] = useState(true); // State to manage loading

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userManager = await getUserManagerAsync(); // Get the user manager
        const userData = await userManager.getUser(); // Fetch the user
        setUser(userData); // Update the user state
      } catch (error) {
        console.error('Error fetching user:', error);
      } finally {
        setLoading(false); // Stop loading
      }
    };

    fetchUser();
  }, []);

  // While loading, show a loading indicator
  if (loading) {
    return <div>Loading...</div>;
  }

  // If no user is found, redirect to the login page
  if (!user) {
    return <Navigate to="/login" />;
  }

  // If the user is authenticated, render child routes
  return <Outlet />;
};

export default ProtectedRoute;
